/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_Ignore_ConfirmInputs */

const vi_expense_sync_ignore_confirm = /** @type {(inputs: Expense_Sync_Ignore_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua giao dịch này? Nó sẽ rời khỏi hàng đợi và không tạo khoản chi.`)
};

/**

* @param {Expense_Sync_Ignore_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_ignore_confirm = /** @type {((inputs?: Expense_Sync_Ignore_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_Ignore_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_ignore_confirm(inputs)
});